"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme, props) {
  var palette = theme.palette,
      appearanceTransform = 'translateX(0)',
      appearanceOpacity = 1,
      cursor = 'pointer';

  if (props.disabled) {
    appearanceOpacity = 0.2;
    cursor = 'not-allowed';
    theme.color = theme.checkedColor = theme.disabledColor;
    theme.hoverColor = theme.checkedHoverColor = theme.disabledColor;
  }

  if (props.checked) {
    theme.background = theme.checkedBackground;
    theme.switcherBackground = theme.checkedSwitcherBackground;
    appearanceTransform = 'translateX(100%)';
  }

  var label = {
    transition: "color ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
    color: theme.color,
    fontSize: theme.fontSize,
    lineHeight: theme.lineHeight,
    textWrap: 'none',
    whiteSpace: 'nowrap',
    wordWrap: 'normal',
    display: 'inline-block',
    verticalAlign: 'middle',
    cursor: cursor,
    userSelect: 'none',
    '&:hover': {
      color: theme.hoverColor
    }
  };
  return {
    root: {},
    wrapper: {
      position: 'relative',
      fontSize: 0,
      fontFamily: theme.fontFamily
    },
    field: {
      display: 'none'
    },
    label: label,
    labelChecked: _objectSpread({}, label, {
      color: theme.checkedColor,
      '&:hover': {
        color: theme.checkedHoverColor
      }
    }),
    icon: {
      display: 'inline-block',
      verticalAlign: 'middle',
      position: 'relative',
      width: '40px',
      height: '14px',
      boxSizing: 'border-box',
      borderRadius: '100px',
      background: theme.background,
      opacity: appearanceOpacity,
      cursor: cursor,
      transition: "background ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
      marginRight: props.checkedLabel ? "".concat(palette.gutter * 2, "px") : 0,
      marginLeft: props.unCheckedLabel ? "".concat(palette.gutter * 2, "px") : 0,
      '&:before': {
        transition: "transform ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
        display: 'block',
        content: '""',
        position: 'absolute',
        top: 'calc(50% - 11px)',
        left: 0,
        transform: appearanceTransform,
        width: '22px',
        height: '22px',
        borderRadius: '50%',
        background: theme.switcherBackground,
        boxShadow: theme.switcherBoxShadow
      }
    }
  };
}